import ActionExpression from "./action-expression";

/**
 * Copyright (c) 2016-2020 Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti
 * All Rights Reserved.
 *
 * The software and data contained herein are confidential and
 * proprietary information of Yega Yazilim ("Confidential Information").
 *
 * Users of this software may not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * they entered into with Yega Yazilim.
 *
 *
 * Author    Ahmet Dogramaci
 * Date      2020-03-11
 */
const WatchExpression =  {
    IS_SELECTED: 'isSelected()',
    IS_UNSELECTED: 'isUnselected()',
    IS_DISABLED: 'isDisabled()',
    IS_ENABLED: 'isEnabled()',
    IS_VISIBLE: 'isVisible()',
    IS_HIDDEN: 'isHidden()'
};
export const WATCH_EXPRESSION_OPTIONS = [
    {id:WatchExpression.IS_SELECTED,label:WatchExpression.IS_SELECTED},
    {id:WatchExpression.IS_UNSELECTED,label:WatchExpression.IS_UNSELECTED},
    {id:WatchExpression.IS_DISABLED,label:WatchExpression.IS_DISABLED},
    {id:WatchExpression.IS_ENABLED,label:WatchExpression.IS_ENABLED},
    {id:WatchExpression.IS_VISIBLE,label:WatchExpression.IS_VISIBLE},
    {id:WatchExpression.IS_HIDDEN,label:WatchExpression.IS_HIDDEN}
];
export default WatchExpression;